<template>
  <div class='dashboard-editor-container'>
    <FilterButton class='github-corner' @handleSearchClick='handleSearchClick' />
    <!--小框图 -总收入+停车数+支付笔数+车位总数 -->
    <el-row :gutter='12'>
      <el-col :sm='24' :xs='24' :md='6' :xl='6' :lg='6' :style="{ marginBottom: '0px' }">
        <chart-card title='总收入(元)' :total='totalIncome'>
          <el-tooltip slot='action' class='item' effect='dark' content='申请退款中也在内'
                      placement='top-start'>
            <i class='el-icon-warning-outline' />
          </el-tooltip>
          <!--          <el-tooltip slot='action' class='item' effect='dark' content=''-->
          <!--                      placement='top-start'>-->
          <!--            <i class='el-icon-warning-outline' />-->
          <!--          </el-tooltip>-->
          <!--          <div>-->
          <!--            &lt;!&ndash;                        <trend flag="top" style="margin-right: 16px;" :rate="incomeMonthRate">&ndash;&gt;-->
          <!--            &lt;!&ndash;                            <span slot="term">月同比</span>&ndash;&gt;-->
          <!--            &lt;!&ndash;                        </trend>&ndash;&gt;-->
          <!--            &lt;!&ndash;                        <trend flag="bottom" :rate="incomeDayRate">&ndash;&gt;-->
          <!--            &lt;!&ndash;                            <span slot="term">日同比</span>&ndash;&gt;-->
          <!--            &lt;!&ndash;                        </trend>&ndash;&gt;-->
          <!--          </div>-->
          <!--          <template slot='footer'>-->
          <!--            &lt;!&ndash;                      日均收入<strong> {{incomeDayAvg}} 元</strong>&ndash;&gt;-->
          <!--            &lt;!&ndash;                        月均收入<strong> {{incomeMonthAvg}} 元</strong>&nbsp;&nbsp;&nbsp;&nbsp;&ndash;&gt;-->
          <!--          </template>-->
        </chart-card>
      </el-col>
      <el-col :sm='24' :xs='24' :md='6' :xl='6' :lg='6' :style="{ marginBottom: '12px' }">
        <chart-card title='总站点数' :total='station_count'>
          <el-tooltip slot='action' class='item' effect='dark' content=''
                      placement='top-start'>
            <i class='el-icon-warning-outline' />
          </el-tooltip>
          <!--                    <div>-->
          <!--                        <MiniAreaParking :chart-data="lineChartData"/>-->
          <!--                    </div>-->
          <!--                    <template slot="footer">日均充电<span> {{parkingAvg }} 次</span></template>-->
        </chart-card>
      </el-col>
      <el-col :sm='24' :xs='24' :md='6' :xl='6' :lg='6' :style="{ marginBottom: '12px' }">
        <chart-card title='总设备数' :total='dev_count'>
          <el-tooltip slot='action' class='item' effect='dark' content=''
                      placement='top-start'>
            <i class='el-icon-warning-outline' />
          </el-tooltip>
          <!--                    <div>-->
          <!--                        <MiniBarPaymentOrder :chart-data="barChartPayOrder"/>-->
          <!--                    </div>-->
          <!--                    <template slot="footer">日均支付 <span>{{payedAvg}}</span> 笔</template>-->
        </chart-card>
      </el-col>
      <el-col :sm='24' :xs='24' :md='6' :xl='6' :lg='6' :style="{ marginBottom: '12px' }">
        <chart-card title='总用户数' :total='total_user'>
          <el-tooltip slot='action' class='item' effect='dark' content='' placement='top-start'>
            <i class='el-icon-warning-outline' />
          </el-tooltip>
          <!--                    <div>-->
          <!--                        <el-row :gutter="24" type="flex" justify="center">-->
          <!--                            <el-col :span="6"><span style="font-size: small">空闲 {{emptyCount}}</span></el-col>-->
          <!--                            <el-col :span="6">-->
          <!--                                <div class="grid-content bg-purple"></div>-->
          <!--                            </el-col>-->
          <!--                            <el-col :span="6">-->
          <!--                                <div class="grid-content bg-purple"></div>-->
          <!--                            </el-col>-->
          <!--                            <el-col :span="6"><span style="font-size: small">占用 {{occupyCount}}</span>-->
          <!--                            </el-col>-->
          <!--                        </el-row>-->
          <!--&lt;!&ndash;                        <mini-progress color="rgb(19, 194, 194)" :target="(percentage+1)" :percentage="percentage"&ndash;&gt;-->
          <!--&lt;!&ndash;                                       height="5px"/>&ndash;&gt;-->
          <!--                    </div>-->
          <!--                    <template slot="footer"><span>占用率 {{accupyPercentage}}%</span></template>-->
        </chart-card>
      </el-col>
    </el-row>
    <!--曲线图--停车次数分析 实停次数+免停次数+逃费次数-->
    <el-row style='background:#fff;padding:16px 16px 0;margin-bottom:32px;'>
      <LineChartParking :chart-data='lineChartData' />
    </el-row>
    <!--饼状图--基础设施统计、停车行为统计、停车时效统计-->
    <el-row :gutter='24'>
      <el-col :xs='24' :sm='24' :lg='12'>
        <div class='chart-wrapper'>
          <PieChartDevice :chart-data='pieChartDeviceData' />
        </div>
      </el-col>
      <el-col :xs='24' :sm='24' :lg='12'>
        <div class='chart-wrapper'>
          <PieChartParking :chart-data='pieChartParkingData' />
        </div>
      </el-col>
<!--      <el-col :xs='24' :sm='24' :lg='8'>-->
<!--        <div class='chart-wrapper'>-->
<!--          <PieChartStops :chart-data='pieChartOccupyHourData' />-->
<!--        </div>-->
<!--      </el-col>-->
    </el-row>

    <!--柱状图--收入统计-->
    <el-row style='background:#fff;padding:16px 16px 0;margin-bottom:32px;'>
      <BarChartPayOrder :chart-data='barChartPayOrder' />
    </el-row>
    <!--滚动排行图---->
    <!--        <el-card :body-style="{padding: '0'}">-->
    <!--            <el-row>-->
    <!--                <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">-->
    <!--                    <ScrollRanking title="站点收入排行榜" :config="incomeRankConfig"/>-->
    <!--                </el-col>-->
    <!--                <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">-->
    <!--                    <ScrollRanking title="站点换电排行榜" :config="paringRankConfig" style="margin-left:8px;"/>-->
    <!--                </el-col>-->
    <!--            </el-row>-->
    <!--        </el-card>-->
    <!--条件查询 弹出框---->
    <el-dialog title='条件过滤' :visible.sync='dialog.visible' width='50%'>
      <el-form ref='form' label-width='80px'>
        <el-form-item label='站点名称'>
          <el-input v-model='dialog.carpark_name' placeholder='请输入站点名称' style='width: 60%;'
                    clearable></el-input>
        </el-form-item>
      </el-form>

      <el-form ref='form' label-width='80px'>
        <el-form-item label='时间范围'>
          <el-date-picker
            style='width: 60%;'
            v-model='dialog.findDateTime'
            type='daterange'
            align='center'
            unlink-panels
            :picker-options='pickerOptions'
            start-placeholder='开始日期'
            end-placeholder='结止日期'
          />
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='dialog.visible = false'>取 消</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='handleSubmitClick'>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import LineChartParking from './LineChartParking'
import PieChartStops from './PieChartStops'
import PieChartDevice from './PieChartDevice'
import PieChartParking from './PieChartParking'
import BarChartPayOrder from './BarChartPayOrder'
import ScrollRanking from './ScrollRanking'
import ChartCard from '@/components/ChartCard'
import Trend from '@/components/Trend'
import MiniAreaParking from './MiniAreaParking'
import MiniBarPaymentOrder from './MiniBarPaymentOrder'
import MiniProgress from '@/components/MiniProgress'
import FilterButton from './FilterButton'
import { formatDateTime } from '@/utils/index'

import { gateway } from '@/api/admin.js'

const barData = []
for (let i = 0; i < 12; i += 1) {
  barData.push({
    x: `${i + 1}月`,
    y: Math.floor(Math.random() * 1000) + 200
  })
}
export default {
  name: 'DashboardAdmin',
  components: {
    FilterButton,
    ChartCard,
    Trend,
    LineChartParking,
    BarChartPayOrder,
    ScrollRanking,
    MiniAreaParking,
    MiniBarPaymentOrder,
    MiniProgress,
    PieChartDevice,
    PieChartParking,
    PieChartStops
  },
  data() {
    return {
      barData,
      incomeRankConfig: {},
      paringRankConfig: {},
      rank: {},
      miniAreaParkingData: {
        dateTimeData: [],
        parkingData: []
      },
      lineChartData: {
        dateTimeData: [],
        parkingData: [],
        realParkingData: [],
        freeParkingData: [],
        abnormalParkingData: []
      },
      pieChartDeviceData: {
        onlineDevCnt: 0,
        offlineDevCnt: 0
      },
      pieChartParkingData: {
        realParkingCnt: 0,
        freeParkingCnt: 0,
      },
      pieChartOccupyHourData: {
        occupyRate: 0,
        freeRate: 0,
        occupyHourOne: 0,
        occupyHourTwo: 0,
        occupyHourSix: 0,
        occupyHourTwelve: 0,
        occupyHourTwentyFour: 0,
        occupyHourN: 0
      },


      start_time: '',
      end_time: '',

      barChartPayOrder: {
        dateTimeData: [],
        payedFeeData: [],
        refundFeeData: [],
        payedCountData: []
      },

      totalIncome: 0,
      total_user: 0,
      station_count: 0,
      dev_count: 0,
      incomeMonthRate: '0',
      incomeDayRate: '0',
      accupyPercentage: 0,

      incomeMonthAvg: 0,
      incomeDayAvg: 0,
      parkingAvg: 0,
      payedAvg: 0,
      totalParking: 0,
      totalPayed: 0,
      carPortCount: 0,
      emptyCount: 0,
      occupyCount: 0,
      percentage: 0,
      dialog: {
        visible: false,
        carpark_name: '',
        findDateTime: []
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 1)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近二个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 2)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 3)
            picker.$emit('pick', [start, end])
          }
        }]
      }

    }
  },
  created() {
    this.request()

  },
  methods: {

    dateFormat(fmt, date) {
      let ret
      const opt = {
        'Y+': date.getFullYear().toString(),        // 年
        'm+': (date.getMonth() + 1).toString(),     // 月
        'd+': date.getDate().toString(),            // 日
        'H+': date.getHours().toString(),           // 时
        'M+': date.getMinutes().toString(),         // 分
        'S+': date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      }
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt)
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
        }

      }
      return fmt
    },

    request() {

      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth()

      this.start_time = this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(year, month, 1))
      this.end_time = this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(year, month + 1, 1))

      this.getIncomeStatistics(month + 1, this.start_time, this.end_time)
      this.getRefundStatistics(month + 1, this.start_time, this.end_time)
      this.getChargeFrequencyStatistics(month + 1, this.start_time, this.end_time)
     // this.getCollectStatistics(month + 1, this.start_time, this.end_time)

      //一年收入
      var sTime = this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(year-1, month, 1))
      var eTime = this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(year, month + 1, 1))
      this.getCollectStatistics(month + 1, sTime, eTime)
    },


    getIncomeStatistics(month, start_time, end_time) {

      let _this = this
      let str = JSON.stringify({
        start_time: start_time,
        end_time: end_time
      })

      gateway({
        func: 'get_income_statistics',
        params: str
      }).then(res => {

        if (res.code == 0) {

          if (res.result !== null) {

            _this.barChartPayOrder.dateTimeData = []
            _this.barChartPayOrder.payedFeeData = []

            for (let i = 0; i < res.result.length; i++) {
              _this.barChartPayOrder.dateTimeData[i] = month + '月' + res.result[i].name + '号'
              _this.barChartPayOrder.payedFeeData[i] = parseFloat(res.result[i].value / 100).toFixed(2)
            }

          }
        }
      })
    },
    mGetDate(year, month) {
      var d = new Date(year, month, 0)
      var count = d.getDate()
      this.chartParams.timeData = []
      this.chartParams.xTimeData = []
      for (var i = 0; i < count; i++) {
        this.chartParams.timeData[i] = i + 1
        this.chartParams.xTimeData[i] = (i + 1) + '号'
      }
      return d.getDate()
    },

    getRefundStatistics(month, start_time, end_time) {
      let _this = this
      let str = JSON.stringify({
        start_time: start_time,
        end_time: end_time
      })
      gateway({
        func: 'get_refund_statistics',
        params: str
      }).then(res => {

        if (res.code == 0) {
          if (res.result !== null) {
            _this.barChartPayOrder.dateTimeData = []
            _this.barChartPayOrder.refundFeeData = []

            for (let i = 0; i < res.result.length; i++) {
              _this.barChartPayOrder.dateTimeData[i] = month + '月' + res.result[i].name + '号'
              _this.barChartPayOrder.refundFeeData[i] = parseFloat(res.result[i].value / 100).toFixed(2)
            }
          }
        }
      })
    },

    getChargeFrequencyStatistics(month, start_time, end_time) {

      let _this = this
      let str = JSON.stringify({
        start_time: start_time,
        end_time: end_time
      })

      gateway({
        func: 'get_charge_frequency_statistics',
        params: str
      }).then(res => {

        if (res.code == 0) {
          if (res.result !== null) {
            _this.lineChartData.dateTimeData = []
            _this.lineChartData.payedFeeData = []

            for (let i = 0; i < res.result.length; i++) {
              _this.lineChartData.dateTimeData[i] = month + '月' + res.result[i].name + '号'
              _this.lineChartData.payedFeeData[i] = res.result[i].value
            }
          }
        }
      })
    },

    getCollectStatistics(month, start_time, end_time) {

      let _this = this

      let str = JSON.stringify({
        start_time: start_time,
        end_time: end_time
      })

      gateway({
        func: 'get_collect_statistics',
        params: str
      }).then(res => {

        if (res.code == 0) {
          if (res.result !== null) {

            // {"code":0,"msg":"","result":{"total_income":"80","total_user":8,"dev_offline":0,"dev_count":3,"dev_online":3,"grid_empty":32,"grid_occupy":10,"pole_empty":24,"pole_occupy":6,"work_group_count":3}}
            //
            _this.totalIncome = (res.result.total_income / 100).toFixed(2)

            _this.total_user = res.result.total_user
            _this.station_count = res.result.station_count
            _this.dev_count = res.result.dev_count

           _this.pieChartDeviceData.onlineDevCnt = res.result.dev_online
            _this.pieChartDeviceData.offlineDevCnt = res.result.dev_offline


            _this.pieChartParkingData.realParkingCnt =  parseInt(res.result.grid_empty)+parseInt(res.result.pole_empty)
            _this.pieChartParkingData.freeParkingCnt = parseInt(res.result.pole_occupy)+parseInt(res.result.grid_occupy)


            _this.pieChartDeviceData.onlineDevCnt = [..._this.pieChartDeviceData.onlineDevCnt]
           _this.pieChartDeviceData.offlineDevCnt = [..._this.pieChartDeviceData.offlineDevCnt]

            _this.pieChartParkingData.realParkingCnt = [..._this.pieChartParkingData.realParkingCnt]
            _this.pieChartParkingData.freeParkingCnt = [..._this.pieChartParkingData.freeParkingCnt]

          }
        }
      })
    },


    //搜索框
    handleSearchClick() {
      this.dialog.visible = true
    }
    ,
    handleSubmitClick() {
      this.dialog.visible = false
      this.request()
    }
  }
}
</script>
<style lang='scss' scoped>
.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}

@media (max-width: 1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}
</style>
